import React from "react";

export interface IconProps {
  width?: string;
  height?: string;
}

function LightningSvg(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 12 13"
    >
      <path
        fill="#FCE626"
        stroke="#233876"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.583 1.25v4.083h4.084l-5.25 6.417V7.667H1.334l5.25-6.417z"
      ></path>
    </svg>
  );
}

export default LightningSvg;
